import { AppBar, Button, ButtonGroup } from "@material-ui/core";
import React, { useMemo } from "react";

export const BackstageChatHeader = (props) => {
  const { currentChat, disableGroupChat, orderList = [], chatTemplate, chats, missedGroupMessages, clientKey, exhibitor = false, deselectChat = () => null, selectChat } = props;
  const undreadEventMessages = useMemo(() => {
    let count = 0;
    chats.map((c) => {
      if (c.seen == false && c.target != currentChat) {
        count += c.messages.filter((m) => m.seen == false && m.receiver == clientKey).length;
      }
      if (c.target == "ALL" && c.seen == false && currentChat != "ALL") {
        count += missedGroupMessages;
      }
    });
    return count > 0;
  }, [chats]);

  const undreadBackstageMessages = useMemo(() => {
    let count = 0;
    chats.map((c) => {
      if (c.seen == false && c.target != currentChat) {
        count += c.messages.filter((m) => m.seen == false && m.receiver == clientKey).length;
      }
      if (c.target == "BACKSTAGE" && c.seen == false && currentChat != "BACKSTAGE") {
        count += missedGroupMessages;
      }
    });
    return count > 0;
  }, [chats]);

  return (
    <AppBar
      position="static"
      style={{
        width: "100%",
        background: "#333333",
        boxShadow: "none",
        maxHeight: 76,
        padding: "10px 0px",

        /*    borderBottom: `1px solid ${header.borderColor}`, */
      }}
      /*       style={{ background: "#222" }} */
    >
      <ButtonGroup
        disableElevation
        variant="contained"
        className="backstage-btn-group"
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Button
          onClick={() => selectChat("BACKSTAGE")}
          variant={currentChat == "BACKSTAGE" ? "contained" : ""}
          size="small"
          style={{ color: "#fff", border: 0, backgroundColor: currentChat == "BACKSTAGE" ? "rgb(22 88 197)" : "transparent", borderRadius: currentChat == "BACKSTAGE" ? 25 : undefined }}
        >
          {undreadBackstageMessages ? <UndreadMessagesDot /> : null} Backstage
        </Button>
        <Button
          onClick={() => selectChat(disableGroupChat ? "NONE2":"ALL")}
          variant={currentChat == "ALL" ? "contained" : ""}
          size="small"
          style={{ color: "#fff", border: 0, backgroundColor: currentChat == "ALL" || currentChat == "NONE2" ? "rgb(22 88 197)" : "transparent", borderRadius: currentChat == "ALL" ? 25 : undefined }}
        >
          {undreadEventMessages ? <UndreadMessagesDot /> : null} Event
        </Button>
        
      </ButtonGroup>
    </AppBar>
  );
};

const UndreadMessagesDot = () => <div className="backstage-undread-message-dot" />;
